import { Stack } from "@mantine/core";
import { Controller } from "react-hook-form";
import { Checkbox } from "@onengine/component-library";
import { FormErrorBox } from "@/components/ui/FormErrorBox/FormErrorBox";
import type { ControlledFieldProps } from "./types";

export function ControlledAcknowledgement({
  name,
  control,
  error,
  clearErrors,
  label,
}: ControlledFieldProps & { label?: string }) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={false}
      render={({ field }) => (
        <Stack gap={6}>
          <Checkbox
            state={field.value ? "selected" : "deselected"}
            onValueChange={(next) => {
              field.onChange(next);
              clearErrors(name);
            }}
            label={label || "I acknowledge the above statement"}
            size="small"
          />
          {error && <FormErrorBox message={error} />}
        </Stack>
      )}
    />
  );
}
